import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["isVisible"];
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import { getPurposes } from '../utils/config';
import Dialog from './dialog';
import ConsentNotice from './consent-notice';
var ConsentNoticeWrapper = /*#__PURE__*/function (_React$Component) {
  function ConsentNoticeWrapper() {
    _classCallCheck(this, ConsentNoticeWrapper);
    return _callSuper(this, ConsentNoticeWrapper, arguments);
  }
  _inherits(ConsentNoticeWrapper, _React$Component);
  return _createClass(ConsentNoticeWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isVisible = _this$props.isVisible,
        props = _objectWithoutProperties(_this$props, _excluded);
      if (!this.props.isMandatory && !isVisible) {
        return null;
      }
      var title = this.props.t(['consentNotice', 'title']);
      var ariaProp = title ? {
        aria: {
          'labelledby': 'orejime-notice-title'
        }
      } : {};
      if (this.props.isMandatory) {
        return /*#__PURE__*/React.createElement(Dialog, _extends({
          isOpen: isVisible
        }, ariaProp, {
          config: this.props.config,
          portalClassName: this.props.ns('NoticePortal'),
          overlayClassName: this.props.ns('NoticeOverlay'),
          className: this.props.ns('NoticeWrapper')
        }), /*#__PURE__*/React.createElement(ConsentNotice, props));
      }
      return /*#__PURE__*/React.createElement(ConsentNotice, props);
    }
  }]);
}(React.Component);
export { ConsentNoticeWrapper as default };